import React from 'react';
import { Link } from 'react-router-dom';

interface LivePlayerStats {
  steam_id: string;
  player_name: string;
  kills: number;
  deaths: number;
  assists: number;
  adr: number;
  kast: number;
  headshot_kills: number;
  mvp: number;
  rating: number;
}

interface LiveTeamStatsSectionProps {
  teamName: string;
  teamLogo: string;
  teamId?: string | number; // Can be UUID (string) or numeric ID
  players: LivePlayerStats[];
  score?: number;
  isWinner?: boolean;
}

const LiveTeamStatsSection: React.FC<LiveTeamStatsSectionProps> = ({
  teamName,
  teamLogo,
  teamId,
  players,
  score,
  isWinner
}) => {
  return (
    <div className="team-section">
      <div className="players-stats">
        <div className="stats-header">
          <div className="player-name-col team-info-header">
            <img
              src={teamLogo}
              alt={teamName}
              className="team-logo-inline"
            />
            <div className="team-text-group">
              <span className="team-name-inline">{teamName}</span>
              {score !== undefined && (
                <span className={`team-score-inline ${isWinner ? "winner-score" : "loser-score"}`}>
                  {score}
                </span>
              )}
            </div>
          </div>
          <div className="stat-col">K</div>
          <div className="stat-col">D</div>
          <div className="stat-col">A</div>
          <div className="stat-col">K/D</div>
          <div className="stat-col">ADR</div>
          <div className="stat-col">HS%</div>
        </div>

        {players.length === 0 ? (
          <div className="player-stats-row" style={{
            gridColumn: '1 / -1',
            textAlign: 'center',
            padding: '1.5rem',
            color: '#888',
            fontSize: '13px',
            fontStyle: 'italic'
          }}>
            Waiting for player data...
          </div>
        ) : (
          players.map((player) => {
            const kd = player.deaths > 0 ? player.kills / player.deaths : player.kills;
            const hsPercent = player.kills > 0 ? (player.headshot_kills / player.kills) * 100 : 0;

            return (
              <div key={player.steam_id} className="player-stats-row">
                <div className="player-name-col">
                  <Link
                    to={`/profile/${player.steam_id}`}
                    className="player-name"
                    style={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    {player.player_name}
                  </Link>
                </div>
                <div className="stat-col">{player.kills}</div>
                <div className="stat-col">{player.deaths}</div>
                <div className="stat-col">{player.assists}</div>
                <div className="stat-col">{kd.toFixed(2)}</div>
                <div className="stat-col">{player.adr.toFixed(1)}</div>
                <div className="stat-col">{hsPercent.toFixed(0)}%</div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default LiveTeamStatsSection;
